import Link from 'next/link';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import { LinksSectionDTO } from '@lib/strapi/dtos/components/sections/linksSection.dto';

const LinksSectionImplementation = ({ section }: ComponentProps<LinksSectionDTO>) => {
  const links = (section as { links?: { title?: string; url?: string }[] } | undefined)?.links ?? [];
  if (!links.length) return null;
  return (
    <div className="my-6 flex flex-wrap gap-3">
      {links.map((l, i) => (
        <Link key={i} href={l.url ?? '#'}
          className="inline-flex items-center gap-1.5 rounded-full border-2 border-violet-700 px-5 py-2.5 text-sm font-extrabold text-violet-700 transition-colors hover:bg-violet-700 hover:text-white">
          {l.title}
        </Link>
      ))}
    </div>
  );
};

export default LinksSectionImplementation;
